import _ from 'lodash'
import { Query } from 'shared-libs/models/query'
import type webApis from 'browser/app/models/apis'
import type { Filter } from 'shared-libs/generated/server-types/analytics/eql/filter/filter'
import type { Response as EqlResponse } from 'shared-libs/generated/server-types/analytics/eql/response'

export class ZipcodeQuery {
  private apis: typeof webApis
  private entityType: string | undefined
  private filterKey: string
  private lastQuery: any

  constructor(apis: typeof webApis, entityType: string | undefined, filters: Filter[], filterKey: string) {
    this.apis = apis
    this.entityType = entityType
    this.filterKey = filterKey
  }

  public cancel() {
    this.lastQuery?.cancel()
    this.lastQuery = null
  }

  public queryLoadCountForZipcode(query: string): Promise<EqlResponse> {
    this.cancel()
    const request = {
      filters: [
        {
          path: `${this.filterKey}.postalCode`,
          type: 'prefix',
          value: query,
        },
      ],
      groups: [
        {
          lanePointBucketType: 'localityRegion',
          path: this.filterKey,
          type: 'lanePoint',
        },
      ],
    }
    const collection = new Query(this.apis)
      .setEntityType(this.entityType)
      .setFilters(request.filters)
      .setGroups(request.groups)
      .setSize(1)
      .setShouldIncludeLeafEntities(false)
      .getCollection()
    this.lastQuery = collection.find()
    return this.lastQuery
      .then(() => collection.result)
      .finally(() => this.lastQuery = null)
  }
}
